<!-- eslint-disable no-irregular-whitespace -->
<template>
    <v-card elevation="0" class="form">
        <v-card-text>
            <v-form ref="form" class="form" v-model="valid">
                <v-container>
                    <typo name="body-18-bold">Votre société</typo>
                    <v-row>
                        <v-col md="4">
                            <v-text-field
                                v-model="values.company.name"
                                label="Raison sociale*"
                                hide-details
                                :rules="[rules.required]"
                                @input="sanitizeHtml('company.name', $event)"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="values.company.address"
                                label="Adresse"
                                hide-details
                                @input="sanitizeHtml('company.address', $event)"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col md="4">
                            <v-text-field
                                v-model="values.company.postCode"
                                label="Code postal"
                                hide-details
                                @input="sanitizeHtml('company.postCode', $event)"
                            />
                        </v-col>
                        <v-col md="4">
                            <v-text-field
                                v-model="values.company.town"
                                label="Ville"
                                hide-details
                                @input="sanitizeHtml('company.town', $event)"
                            />
                        </v-col>
                    </v-row>

                    <sep name="L"></sep>

                    <typo name="body-18-bold">Vos informations</typo>
                    <v-row>
                        <v-col>
                            <v-radio-group v-model="values.title" row hide-details>
                                <v-radio label="Mme" value="mme"></v-radio>
                                <v-radio label="M" value="m"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col md="4">
                            <v-text-field
                                label="Nom*"
                                hide-details
                                required
                                v-model="values.lastName"
                                :rules="[rules.required]"
                                @input="sanitizeHtml('lastName', $event)"
                            />
                        </v-col>
                        <v-col md="4">
                            <v-text-field
                                label="Prénom*"
                                hide-details
                                required
                                v-model="values.firstName"
                                :rules="[rules.required]"
                                @input="sanitizeHtml('firstName', $event)"
                            />
                        </v-col>
                        <v-col md="4">
                            <v-text-field
                                label="Fonction*"
                                hide-details
                                required
                                v-model="values.function"
                                :rules="[rules.required]"
                                @input="sanitizeHtml('function', $event)"
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col md="8">
                            <v-text-field
                                label="Email*"
                                hide-details
                                required
                                v-model="values.email"
                                :rules="[rules.required]"
                                @input="sanitizeHtml('email', $event)"
                            />
                        </v-col>
                        <v-col md="4">
                            <v-text-field
                                label="Téléphone*"
                                hide-details
                                required
                                v-model="values.phone"
                                :rules="[rules.required, rules.phone]"
                                @input="sanitizeHtml('phone', $event)"
                            />
                        </v-col>
                    </v-row>

                    <sep name="L"></sep>

                    <typo name="body-18-bold">Votre message</typo>
                    <v-row>
                        <v-col>
                            <v-textarea
                                label="Rédigez votre demande"
                                v-model="values.message"
                                hide-details
                                @input="sanitizeHtml('message', $event)"
                            ></v-textarea>
                        </v-col>
                    </v-row>

                    <typo class="legend" name="body-12-normal">
                        <p>
                            Conformément à la loi Informatique et libertés du 6 janvier 1978 modifiée, la collecte de
                            ces informations nous est nécessaire pour vous répondre, et/ou vous adresser toute
                            documentation ou tout type de document. Ces informations sont destinées au propriétaire du
                            site web PRIMA S.E.T.
                        </p>
                        <p>
                            Vous disposez d'un droit d’accès, de rectification et de suppression portant sur les données
                            vous concernant. Vous pouvez à tout moment vous opposer à recevoir des informations
                            commerciales de notre part en écrivant au propriétaire du site web ou en contactant notre
                            délégué à la protection des données (cf. « mentions légales »).
                        </p>
                    </typo>

                    <sep name="M"></sep>

                    <typo name="body-12-normal">* champs obligatoires</typo>

                    <sep name="M"></sep>

                    <div class="actions">
                        <action name="main" @click="validate()">Envoyer</action>
                    </div>
                </v-container>
            </v-form>
        </v-card-text>
    </v-card>
</template>
<script>
import Vue from "vue";
import { required, phone } from "src/utils/vform-rules";
import { EventBus } from "src/bus/eventBus";
import { Services } from "src/services/Services";

export default Vue.extend({
    props: ["user"],
    data() {
        return {
            valid: true,
            isSubmitting: false,
            rules: { required, phone },
            values: {
                company: this.user.company,
                firstName: this.user.firstName,
                lastName: this.user.lastName,
                function: this.user.function,
                phone: this.user.phone,
                email: this.user.email,
                title: "",
                message: "",
            },
        };
    },
    methods: {
        async validate() {
            console.log("validate");

            if (this.$refs.form.validate()) {
                try {
                    this.isSubmitting = true;
                    console.log(this.values);
                    await Services.api.contact.sendMail(this.values);
                    EventBus.$emit("alert:success", { message: "Votre message a bien été envoyé" });
                } catch (error) {
                    EventBus.$emit("alert:error", {
                        message: "Une erreur est survenue lors de l'envoi de votre message",
                    });
                } finally {
                    this.isSubmitting = false;
                }
            }
        },
        onSnackbarClose() {
            this.snackbar = null;
        },
        sanitizeHtml(key, value) {
            if (value.includes("<") || value.includes(">")) {
                this.values[key] = value.replace(/[<>]/g, "");
                return false;
            }
        },
    },
});
</script>

<style lang="sass" scoped>
.form
    background-color: $color-background

.actions
    display: flex
    justify-content: flex-start

.body-18-bold
    display: block
    color: $color-text
    text-transform: uppercase

.legend
    ::v-deep
        .v-input,
        .v-label
            font-size: inherit
</style>
